import { Fragment, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  clearRowsList,
  clearSettingsList,
  findColumnSetting,
} from '../../../actions/agGrid';
import {
  clearAttributeList,
  findAllAttributes,
} from '../../../actions/attribute';
import AttributeView from '../../Reusable/Filter/AttributeView';
import AgGridAction from '../Header/AgGridAction';
import AgGridHeaderRow from '../Header/AgGridHeaderRow';

const AgGridHeader = (props) => {
  const dispatch = useDispatch();
  const {
      gridRef,
      type,
      columnSettingsList,
      filterSettings,
      t,
      gt,
      enums,
      tableTitle,
      action,
      setAction,
      rowsChecked,
      filterActive,
      collapseSearch,
      showAttributeView,
      inForm,
      modalData,
      selectedRow,
      setSelectedRowForForm,
      useSelectedRowLabel,
      setSelectedRow,
      hideSubmitButton,
      singleSelect,
      additionalFilterCriteria,
      setFilterActive,
      additionalProps,
      setRowsChecked,
      propertyForDelete,
      dontShowButtonForUse,
      dontShowButtons,
      withoutActionColumn,
      setAgGridType,
      initialSearch,
      buttonsTranslation,
      customHeaderComponent,
    } = props || {},
    { Header, ValidityPeriodModal, ModalForExport, NotificationMessages } =
      t || {};

  const [refreshState, setRefreshState] = useState(false);

  useEffect(() => {
    dispatch(
      findColumnSetting(type, NotificationMessages, inForm, withoutActionColumn)
    );
    dispatch(findAllAttributes(type, NotificationMessages, inForm));
  }, [
    dispatch,
    type,
    refreshState,
    NotificationMessages,
    inForm,
    withoutActionColumn,
  ]);

  useEffect(() => {
    return () => {
      dispatch(clearRowsList(type));
      dispatch(clearSettingsList(type));
      dispatch(clearAttributeList(type));
    };
  }, [dispatch, type]);

  return (
    <Fragment>
      {!!showAttributeView && (
        <AttributeView
          gridRef={gridRef}
          attributeList={filterSettings}
          tableName={type}
          setRefreshState={setRefreshState}
          refreshState={refreshState}
          collapse={collapseSearch}
          inForm={inForm}
          additionalFilterCriteria={additionalFilterCriteria}
        />
      )}
      <AgGridHeaderRow
        gridRef={gridRef}
        translations={{
          Header,
          ValidityPeriodModal,
          ModalForExport,
          gt,
          NotificationMessages,
        }}
        tableTitle={tableTitle}
        type={type}
        action={action}
        setRefreshState={setRefreshState}
        refreshState={refreshState}
        rowsChecked={rowsChecked}
        filterActive={filterActive}
        columnSettingsList={columnSettingsList}
        setAction={setAction}
        inForm={inForm}
        modalData={modalData}
        selectedRow={selectedRow}
        setSelectedRowForForm={setSelectedRowForForm}
        useSelectedRowLabel={useSelectedRowLabel}
        dontShowButtons={dontShowButtons}
        singleSelect={singleSelect}
        setFilterActive={setFilterActive}
        dontShowButtonForUse={dontShowButtonForUse}
        setAgGridType={setAgGridType}
        buttonsTranslation={buttonsTranslation}
        customHeaderComponent={customHeaderComponent}
      />
      <AgGridAction
        gt={gt}
        enums={enums}
        action={action}
        setAction={setAction}
        gridRef={gridRef}
        tableName={type}
        initialSearch={initialSearch}
        additionalFilterCriteria={additionalFilterCriteria}
        inForm={inForm}
        setSelectedRow={setSelectedRow}
        hideSubmitButton={hideSubmitButton}
        additionalProps={additionalProps}
        rowsChecked={rowsChecked}
        selectedRow={selectedRow}
        setRowsChecked={setRowsChecked}
        columnSettingsList={columnSettingsList}
        propertyForDelete={propertyForDelete}
      />
    </Fragment>
  );
};

export default AgGridHeader;
